__turbopack_context__.v({
  "darker": "skeleton-module-scss-module__r6lXkq__darker",
  "default": "skeleton-module-scss-module__r6lXkq__default",
  "shimmer": "skeleton-module-scss-module__r6lXkq__shimmer",
  "skeleton": "skeleton-module-scss-module__r6lXkq__skeleton",
  "wrapper": "skeleton-module-scss-module__r6lXkq__wrapper",
});
